import * as actionTypes from '../actions/actionTypes';
import {updateState} from "../../shared/util";

const initialState = {
    portalSettings: null,
    loading: false,
    error: null
};

const getPortalSettingsRequest = (state, action) => {
    return updateState(state, {
        loading: true,
        error: null,
        portalSettings: null
    });
};

const getPortalSettingsSuccess = (state, action) => {
    return updateState(state, {
        loading: false,
        error: null,
        portalSettings: action.data
    });
};

const getPortalSettingsError = (state, action) => {
    return updateState(state, {
        loading: false,
        error: action.error
    });
};

const clearPortalSettingsError = (state, action) => {
    return updateState(state, {
        error: null
    });
};

export function portalSettingsReducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.GET_PORTAL_SETTINGS_REQUEST :
            return getPortalSettingsRequest(state, action);

        case actionTypes.GET_PORTAL_SETTINGS_SUCCESS :
            return getPortalSettingsSuccess(state, action);

        case actionTypes.GET_PORTAL_SETTINGS_ERROR :
            return getPortalSettingsError(state, action);


        case actionTypes.CLEAR_ALL_ERRORS :
            return clearPortalSettingsError(state, action);

        default:
            return state;
    }
}
